import { useTheme } from '../contexts/useTheme';
import { Sun, Moon } from 'lucide-react';

export const ThemeSwitcher = () => {
  const { theme, toggleTheme } = useTheme();

  return (
    <button
      onClick={toggleTheme}
      className="relative p-2 rounded-lg transition-all duration-200 focus:outline-hidden focus:ring-2 focus:ring-teal-500 focus:ring-offset-2"
      style={{
        backgroundColor: theme === 'dark' ? 'rgba(30, 41, 59, 0.6)' : 'rgba(241, 245, 249, 0.6)',
      }}
      aria-label={`Switch to ${theme === 'light' ? 'dark' : 'light'} mode`}
      title={`Switch to ${theme === 'light' ? 'dark' : 'light'} mode`}
    >
      {/* Sun icon - shown in dark mode */}
      <Sun
        className={`w-5 h-5 transition-all duration-300 ${
          theme === 'dark'
            ? 'rotate-0 scale-100 opacity-100'
            : 'rotate-90 scale-0 opacity-0 absolute'
        }`}
        style={{ color: 'var(--color-text-secondary)' }}
      />

      {/* Moon icon - shown in light mode */}
      <Moon
        className={`w-5 h-5 transition-all duration-300 ${
          theme === 'light'
            ? 'rotate-0 scale-100 opacity-100'
            : '-rotate-90 scale-0 opacity-0 absolute'
        }`}
        style={{ color: 'var(--color-text-secondary)' }}
      />
    </button>
  );
};
